// config.js (Firebase v9 modular version)
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
 apiKey: "AIzaSyBGo9pqB7EPhqKUG8mkdlOMrqxsl_zlPRM",
  authDomain: "trueledgerassits.firebaseapp.com",
  databaseURL: "https://trueledgerassits-default-rtdb.firebaseio.com",
  projectId: "trueledgerassits",
  storageBucket: "trueledgerassits.firebasestorage.app",
  messagingSenderId: "519470900372",
  appId: "1:519470900372:web:c7b9ee05578619a5280081"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Export the needed services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };

